import { getHomePage, getSolution } from '@/api/modules/personal.js';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  name: 'banner',
  data() {
    return {
      solutionList: [],
      mySwiper: null,
      tabList: []
    };
  },
  methods: {
    toSee(url) {
      window.open(url);
    }
  },
  mounted() {
    getSolution().then(res => {
      if (res.code === 1) {
        this.tabList = res.result;
      }
    });
    getHomePage().then(res => {
      if (res.code === 1) {
        this.solutionList = res.result;
        this.$nextTick(() => {
          if (this.mySwiper) {
            this.mySwiper.destroy();
          }
          this.mySwiper = new Swiper('.swiper-container', {
            observer: true,
            // 修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,
            // 修改swiper的父元素时，自动初始化swiper
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            }
          });
        });
      }
    });
  }
};